import React, { useState, useEffect } from "react";
import {
  ChevronDown,
  ChevronRight,
  Building2,
  BadgeDollarSign,
  Users2,
  SlidersHorizontal,
  ShoppingCart,
  Briefcase,
  Boxes,
  CreditCard,
  Settings,
  Bell,
  Zap,
  Database,
  Puzzle,
} from "lucide-react";

const iconMap = {
  Organization: <Building2 className="w-5 h-5 mr-3 text-gray-500" />,
  Organisation: <Building2 className="w-5 h-5 mr-3 text-gray-500" />,
  "Taxes & Compliance": <BadgeDollarSign className="w-5 h-5 mr-3 text-gray-500" />,
  "Tax & Compliance": <BadgeDollarSign className="w-5 h-5 mr-3 text-gray-500" />,
  "Users & Roles": <Users2 className="w-5 h-5 mr-3 text-gray-500" />,
  // Preferences: <SlidersHorizontal className="w-5 h-5 mr-3 text-gray-500" />,
  Sales: <ShoppingCart className="w-5 h-5 mr-3 text-gray-500" />,
  Purchases: <Briefcase className="w-5 h-5 mr-3 text-gray-500" />,
  Items: <Boxes className="w-5 h-5 mr-3 text-gray-500" />,
  "Online Payments": <CreditCard className="w-5 h-5 mr-3 text-gray-500" />,
  Customisation: <Settings className="w-5 h-5 mr-3 text-gray-500" />,
  "Reminders & Notifications": <Bell className="w-5 h-5 mr-3 text-gray-500" />,
  Automation: <Zap className="w-5 h-5 mr-3 text-gray-500" />,
  "Developer & Data": <Database className="w-5 h-5 mr-3 text-gray-500" />,
  "Integrations & Marketplace": <Puzzle className="w-5 h-5 mr-3 text-gray-500" />,
};

const SettingsSidebar = ({
  open,
  sections = [],
  activeSection,
  activeItem,
  onMenuClick,
  onClose,
  children,
}) => {
  const [expandedSection, setExpandedSection] = useState(activeSection || "Organisation");

  useEffect(() => {
    setExpandedSection(activeSection || "Organisation");
  }, [activeSection]);

  // const enrichedSections = sections.map((section) => {
  //   if (section.title === "Organisation" || section.title === "Organization") {
  //     const currentItems = section.items.map((item) => item.toLowerCase());
  //     const additions = [];

  //     if (!currentItems.includes("numbering configuration")) {
  //       additions.push("Numbering Configuration");
  //     }
  //     if (!currentItems.includes("document create")) {
  //       additions.push("Document Create");
  //     }

  //     return {
  //       ...section,
  //       items: [...section.items, ...additions],
  //     };
  //   }
  //   return section;
  // });

  const enrichedSections = sections.map((section) => {

  // =====================================================
  // ORGANISATION
  // =====================================================
  if (
    section.title === "Organisation" ||
    section.title === "Organization"
  ) {
    const currentItems = section.items.map((item) =>
      item.toLowerCase()
    );

    const additions = [];

    if (!currentItems.includes("numbering configuration")) {
      additions.push("Numbering Configuration");
    }

    if (!currentItems.includes("document create")) {
      additions.push("Document Create");
    }

    return {
      ...section,
      items: [...section.items, ...additions],
    };
  }


  // =====================================================
  // INTEGRATIONS & MARKETPLACE
  // =====================================================
  if (
    section.title === "Integrations & Marketplace"
  ) {
    const currentItems = section.items.map((item) =>
      item.toLowerCase()
    );

    const additions = [];

    if (!currentItems.includes("whatsapp cloud api")) {
      additions.push("WhatsApp Cloud API");
    }

    if (!currentItems.includes("whatsapp templates")) {
      additions.push("WhatsApp Templates");
    }

    return {
      ...section,
      items: [...section.items, ...additions],
    };
  }


  return section;
});

  if (!open) return null;

  return (
    <div
      className="absolute top-0 left-0 bottom-0 right-0 flex w-full z-50"
      style={{ height: "calc(100vh - 56px)" }}
    >
      <aside className="w-68 bg-white border-r border-gray-200 flex flex-col py-6 px-0 shadow-sm">
        <div className="flex items-center justify-between px-4 mb-4">
          <span className="text-xl text-gray-800 tracking-tight">Settings</span>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-700 rounded p-0 focus:outline-none focus:ring-2 focus:ring-blue-200"
            aria-label="Close sidebar"
          >
            <span className="text-2xl leading-none">×</span>
          </button>
        </div>
        <nav className="flex-1 overflow-y-auto pr-2" aria-label="Settings navigation">
          {enrichedSections.map((section) => {
            const isExpanded = expandedSection === section.title;
            return (
              <div key={section.title}>
                <button
                  type="button"
                  className="flex items-center justify-between w-full px-6 pr-3 py-2 cursor-pointer text-sm text-gray-600 hover:bg-gray-50 rounded font-normal"
                  onClick={() => setExpandedSection(isExpanded ? null : section.title)}
                  aria-expanded={isExpanded}
                  style={{ margin: 0 }}
                >
                  <span className="flex items-center">
                    {iconMap[section.title] || (
                      <Settings className="w-5 h-5 mr-3 text-gray-500" />
                    )}
                    {section.title}
                  </span>
                  {isExpanded ? (
                    <ChevronDown className="w-4 h-4 text-gray-400" />
                  ) : (
                    <ChevronRight className="w-4 h-4 text-gray-400" />
                  )}
                </button>
                {isExpanded && (
                  <ul className="mt-0">
                    {section.items.map((item) => {
                      const isActive = activeSection === section.title && activeItem === item;
                      return (
                        <li key={item} style={{ margin: 0 }}>
                          <button
                            className={`w-full text-left py-2 pl-14 pr-4 rounded transition text-sm font-normal ${
                              isActive ? "bg-blue-50 text-blue-600" : "hover:bg-gray-100 text-gray-800"
                            } focus:outline-none focus:ring-2 focus:ring-blue-200`}
                            style={{ margin: 0 }}
                            onClick={() => onMenuClick(section.title, item)}
                            aria-current={isActive ? "page" : undefined}
                          >
                            {item}
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </div>
            );
          })}
        </nav>
      </aside>
      <main className="flex-1 bg-gray-50 p-0 overflow-auto min-h-full">
        <div className="w-full bg-white shadow border border-gray-100 p-8 min-h-full">{children}</div>
      </main>
    </div>
  );
};

export default SettingsSidebar;
